import React, { useState, useEffect } from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Check from '@hydra/assets/img/check.svg';

import Translate, { useI18n } from '@hydra/common/components/i18n';
import Image from '@hydra/common/components/Image';
import Icon from '@hydra/common/components/Icon';
import PdfNotAllowedError from '@hydra/assets/img/pdf/pdf_not_allowed_error.svg';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  dialogTitle: { textAlign: 'center' },
  title: { fontWeight: theme.typography.fontWeightSemibold },
  content: {
    textAlign: 'center',
    padding: theme.spacing(3)
  },
  svgContainer: {
    margin: '0 auto',
    width: 250,
    height: 190,
    position: 'relative'
  },
  svgGraph: {
    position: 'absolute',
    top: 0,
    left: 0
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  },
  itemContainer: {
    '& ul': {
      maxWidth: '60%',
      display: 'inline-block',
      padding: 0,
      margin: theme.spacing(1, 'auto'),
      '& li': {
        display: 'flex',
        padding: theme.spacing(0.5, 1),
        alignItems: 'flex-start',
        fontWeight: theme.typography.fontWeightSemibold,
        justifyContent: 'flex-start',
        listStyleType: 'none',
        textAlign: 'left',
        '&:before': {
          width: theme.spacing(2),
          height: theme.spacing(2),
          content: '""',
          flexShrink: 0,
          marginTop: theme.spacing(0.5),
          marginRight: theme.spacing(1),
          backgroundSize: 'contain',
          backgroundImage: `url(${Check})`
        }
      }
    }
  },
  icon: {
    marginRight: theme.spacing(1),
    fontWeight: theme.typography.fontWeightSemibold
  }
}));

interface IDownloadPdfDialog {
  open: boolean,
  errorMessage?: string
}

export const DownloadPdfDialog = ({ open, errorMessage }: IDownloadPdfDialog) => {
  const { locale } = useI18n();
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);
  const handleClose = () => setIsOpen(false);
  useEffect(() => {
    setIsOpen(open);
  }, [open]);
  return (
    <Dialog fullWidth maxWidth='sm' open={isOpen} onClose={() => handleClose()}>
      {
        errorMessage === 'unallowed'
          ? (
            <>
              <DialogTitle disableTypography className={classes.dialogTitle}>
                <IconButton aria-label='close' className={classes.closeButton} onClick={handleClose}>
                  <Icon type='cross' />
                </IconButton>
              </DialogTitle>
              <DialogContent className={classes.content}>
                <div className={classes.svgContainer}>
                  <Image src={PdfNotAllowedError} className={classes.svgGraph} />
                </div>
                <Typography variant='h3' component='h2' gutterBottom>
                  <Translate content='pdf_dialog_upgrade_title' className={classes.title} />
                </Typography>
                <Grid container justify='center'>
                  <Grid xs={10} className={classes.itemContainer}>
                    <Typography paragraph color='textSecondary'>
                      <Translate content='pdf_dialog_upgrade_text' />
                    </Typography>
                  </Grid>
                </Grid>
                <Button
                  size='large'
                  color='primary'
                  variant='contained'
                  href={`/${locale}/user/plan?pdfBlckd=1`}
                >
                  <Translate content='pdf_dialog_upgrade_cta' />
                </Button>
              </DialogContent>
            </>
            )
          : (
            <>
              <DialogTitle disableTypography className={classes.dialogTitle}>
                <Typography variant='h3' component='h2' gutterBottom>
                  <Translate content='error_oops' className={classes.title} />
                </Typography>
                <IconButton aria-label='close' className={classes.closeButton} onClick={handleClose}>
                  <Icon type='cross' />
                </IconButton>
              </DialogTitle>
              <DialogContent className={classes.content}>
                <Typography paragraph color='textSecondary'>
                  <Translate content='error_unexpected' />
                </Typography>
              </DialogContent>
            </>
            )
      }
    </Dialog>
  );
};

export default DownloadPdfDialog;
